import React, { FC, SVGProps } from 'react';

export const Housing: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#BAE1D1" />
    <path
      d="M21 37.5769C21 35.3009 21.9695 33.1326 23.6656 31.615L37.3328 19.3864C38.8514 18.0277 41.1486 18.0277 42.6672 19.3864L56.3344 31.615C58.0305 33.1326 59 35.3009 59 37.5769V54C59 57.3137 56.3137 60 53 60H27C23.6863 60 21 57.3137 21 54V37.5769Z"
      stroke="#26313B"
      strokeWidth="2"
    />
    <path
      d="M32 46C32 41.5817 35.5817 38 40 38C44.4183 38 48 41.5817 48 46V60H32V46Z"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
    />
  </svg>
);
